module.exports = __webpack_public_path__ + "img/skimmer_parked.b0f82007.svg";